import React, {Component, PureComponent} from "react";
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import {AlertModal, helper} from "../app";

export default class ProjectItems extends Component 
{
    doSayChangeProducts = false;
    constructor (props)
    {
        super(props);

        this.state = {
            products: this.props.products,
            alert_message: ''
        }

        this.setQuantity = this.setQuantity.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
    }
    setQuantity (itemID, quantity)
    {
        if (this.props.can_set_count && itemID in this.state.products)
        {
            quantity = parseInt(quantity);

            if (isNaN(quantity) || (quantity && quantity < 0))
            {
                this.setState({alert_message: 'Некорректное значение количества'});
            }
            else
            {
                if (quantity > 0) 
                {
                    const products = this.state.products;
                
                    products[itemID].quantity = quantity;

                    this.doSayChangeProducts = true;
                    this.setState({products});   
                }
                else
                {
                    this.deleteItem(productID);
                }    
            } 
        }
    }
    deleteItem (productID)
    {
        if (this.props.can_delete && productID in this.state.products)
        {
            const products = this.state.products;

            //console.log(`delete ${productID}`, products[productID]);            
            products[productID].children.forEach(productID => 
            {
                //console.log(`delete ${productID}`);
                delete products[productID];
            });
            delete products[productID];

            this.doSayChangeProducts = true;
            this.setState({products});            
        }
    }
    render () 
    {
        const haveFragments = !helper.isNotObjectOrEmpty(this.props.fragments),            
            fragmentsList = haveFragments ? Object.keys(this.props.fragments).map(fragmentID => 
            {
                const fragment = this.props.fragments[fragmentID];
                return <div key={`pi_fragment${fragmentID}`} className="d-inline-block mt-n1 mr-2">
                    <Button onClick={e => this.props.on_select_fragment(fragmentID)} as="a" variant="outline-secondary" className={"btn-outline-secondary_dashed"+(fragmentID == this.props.fragment ? " active" : '')} size="sm">{fragment.name}</Button>                        
                </div>
            }) : [],
            haveProducts = !helper.isNotObjectOrEmpty(this.state.products),
            productsList = haveProducts ? Object.keys(this.state.products).map(productID => 
            {
                const product = this.state.products[productID],
                    productData = product.data;
                            
                return  <tr key={`product${productID}`}>
                            <td className="align-middle">{productData.articul}</td>
                            <td className="align-middle">{productData.name}</td>
                            <td className="align-middle"><Form.Control onChange={e => this.setQuantity(productID, e.target.value)} value={product.quantity} disabled={!this.props.can_set_count} className="product_quantity_field" size="sm" type="text" /></td>
                            <td className="align-middle">{productData.price.toFixed(2)}</td>
                            <td className="align-middle">{this.props.can_delete
                                ? <button onClick={e => this.deleteItem(productID)} type="button" className="close" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                : ''
                            }</td>                                    
                        </tr>;
            }) : [];

        return (
            productsList.length || (!productsList.length && fragmentsList.length > 1)
                ? <><Form>                        
                        <Accordion defaultActiveKey="0">
                            <h3 className="d-inline-block align-middle fw-500 f-21mob color-blue">Вы выбрали</h3>
                            <div className="d-inline-block ml-5 align-middle">
                                {fragmentsList}
                            </div>
                            <Accordion.Collapse className="pt-3" eventKey="0">
                                {productsList.length
                                    ? <Table hover responsive>
                                        <thead>
                                            <tr>
                                                <th className="f-16 color-gray">Артикул</th>
                                                <th className="f-16 color-gray">Наименование</th>
                                                <th className="f-16 color-gray">Количество, шт</th>
                                                <th className="f-16 color-gray">Стоимость, руб</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {productsList}
                                        </tbody>
                                    </Table>
                                    : <div />
                                }
                            </Accordion.Collapse>
                        </Accordion>            
                    </Form>
                    <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>
                : ''
        );
    }
    componentDidUpdate () 
    {
        if (this.doSayChangeProducts)
        {
            this.doSayChangeProducts = false;
            this.props.on_change_products(this.state.products);
        }        
    }
}
/* @todo 
<Accordion.Toggle as="a" className="txt_interactive ml-3 mt-1" eventKey="0">развернуть</Accordion.Toggle>
*/
